import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getUsersSupplies } from '@/shared/store/supplies/actions';
import { Agreement } from '@/shared/api/borrow';

export const useFetchUserSupplies = (
    walletAddress: string,
    blockchainName: string,
    agreements: Agreement[],
) => {
    const dispatch = useDispatch();

    const fetchSupplies = useCallback(() => {
        dispatch(getUsersSupplies());
    }, [dispatch]);

    useEffect(() => {
        if (walletAddress && blockchainName) {
            fetchSupplies();
        }
    }, [walletAddress, blockchainName, agreements, fetchSupplies]);
};
